<template>
<pop-up-layout 
  :title="$t('reservas.listas.enviarRecordatorio')"
  :aceptar="$t('reservas.listas.enviarCorreo')"
  :saving="waitingForLoad"
  @volver="$parent.hide()"
  @aceptar="enviarCorreo()"
>
  <v-layout column justify-center align-center>
    <o-description-title class="text-xs-center" style="margin-top: 10px">
      {{$t('reservas.listas.recordatorioTexto', {nombre: nombreActor(), reserva: reservaSeleccionada.inmueble_descripcionLarga})}}
    </o-description-title>
    <o-description-title class="text-xs-center">
      {{$t('reservas.listas.reservaModulo', {modulo: getModulo()})}}
    </o-description-title>
  </v-layout>
</pop-up-layout>
</template>

<script>
import { mapActions } from 'vuex'
import modulos from '@/mixins/modulos'

export default {
  mixins: [
    modulos
  ],
  props: ['reservaSeleccionada'],
  data () {
    return {
      waitingForLoad: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      mandarCorreo: 'reservas/enviarCorreoAviso'
    }),
    getModulo () {
      let indexModulo = this.getModuloActual(this.reservaSeleccionada)
      return indexModulo === -1 ? this.$t('reservas.listas.completada') : this.$t('reservas.listas.estadoReservaModulo', {modulo: this.getTexto('modulos.' + this.reservaSeleccionada.modulosOrden.modulos[indexModulo].tipo + (this.reservaSeleccionada.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : '')), indexModulo: (indexModulo), reserva: this.reservaSeleccionada.modulosOrden.modulos.length})
    },
    async enviarCorreo () {
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.mandarCorreo(this.reservaSeleccionada.id)
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('reservas.listas.correoExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    nombreActor () {
      return this.reservaSeleccionada.actor != null ? this.$t('reservas.listas.a', {
        nombre: this.reservaSeleccionada.actor.nombre + ' ' + this.reservaSeleccionada.actor.apellidos
      }) : this.$t('reservas.listas.alUsuario')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/listas/PopUpEnviarRecordatorio.vue